import { render } from "./ToggleComponent.vue?vue&type=template&id=1b6f6c20"
import script from "./ToggleComponent.vue?vue&type=script&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__